// extracted by mini-css-extract-plugin
export default {"container":"Title-module__container__HDxa6zw","header":"Title-module__header__ytUOpIn","expandButton":"Title-module__expandButton__iRvA5BA"};